import React from "react";
import ELayout from "./ELayout";
import Account from "../Account";

const EAccount = () => {
  return (
    <ELayout heading="Account">
        <Account/>
    </ELayout>
);
};

export default EAccount;
